export default __webpack_public_path__ + "static/warning-messages-body-do-6d1e9ea575cdc8ca7ad2f3e9ffc090e3.png";